import { VecLike } from "./vec-like";

export interface Vec{
	readonly vecType:Vec;
	readonly cloneType:this;

	x:number;
	y:number;
	z?:number;

	toArray():[number,number]|[number,number,number];
	toArray<T extends {[i:number]:number}>(out:T, i?:number):T;
	fromArray(array:ArrayLike<number>, i?:number):this;

	clone():this;
	toVec():this['vecType'];
	toXY():Vec;
	toXYZ(z:number):Vec;

	copy(that:VecLike):this;
	applyFunc(fn:(v:number, axis:'x'|'y'|'z')=>number):this;
	setAll(v:number):this;

	neg():this;
	inv():this;
	abs():this;
	floor():this;
	ceil():this;
	round():this;
	
	min(that:VecLike):this;
	max(that:VecLike):this;
	add(that:VecLike):this;
	addScaled(that:VecLike, s:number):this;
	sub(that:VecLike):this;
	mul(that:VecLike):this;
	div(that:VecLike):this;
	mod(that:VecLike):this;
	lerp(that:VecLike, f:number):this;
	mean(that:VecLike):this;
	mix(that:VecLike, f:VecLike):this;

	delta(that:VecLike):this['vecType'];

	sum(a:VecLike, b:VecLike):this;
	diff(a:VecLike, b:VecLike):this;
	blend(a:VecLike, b:VecLike, f:number):this;

	translate(x:number, y:number):this;
	scale(scale:number):this;
	invScale(scale:number):this;
	frac():this;

	dot(that:VecLike):number;
	lenSq():number;
	len():number;
	nrm():this;

	distToSq(that:VecLike):number;
	distTo(that:VecLike):number;
	distToSqXY(that:VecLike):number;
	distToXY(that:VecLike):number

	rotateXY(angle:number):this;
	rotate90XY():this;

	eq(that:VecLike):boolean;
	isValid():boolean;
	isFinite():boolean;

	readonly tmpA:Vec;
	readonly tmpB:Vec;
	readonly tmpC:Vec;
}

export namespace Vec{
	export function azimuth(that:VecLike):number|undefined;
	export function azimuth<T extends Vec>(that:T, az:number, len?:number):T;
	export function azimuth<T extends Vec>(that:T, az?:number, len?:number):number|undefined|T;
	export function azimuth<T extends Vec>(that:T, az?:number, len?:number){
		if(az===undefined){
			if(that.x===0 && that.y===0)
				return undefined;
			return Math.atan2(that.x,that.y);
		}
		len??=Math.sqrt(that.x**2+that.y**2);
		that.x=Math.sin(az)*len;
		that.y=Math.cos(az)*len;
		return that;
	}
// 	export function mean(those:[]):null;
// 	export function mean<T extends Vec>(those:[T,...T[]]):T;
// 	export function mean<T extends Vec>(those:Iterable<T>):T|null;
// 	export function mean(those:Iterable<Vec>):Vec|null{
// 		let out:Vec|null=null;
// 		let count=0;
// 		for(const that of those){
// 			if(out)
// 				out.add(that);
// 			else			
// 				out=that.clone();
// 			count+=1;
// 		}
// 		out?.invScale(count);
// 		return out;
// 	}
}
